import React from 'react';

export default function Sparkline({ data, color = '#1D9E75', width = 60, height = 24, fill = true, strokeWidth = 1.5 }) {
  if (!data || data.length < 2) return null;

  const filtered = data.filter(v => v != null && !isNaN(v));
  if (filtered.length < 2) return null;

  const min = Math.min(...filtered);
  const max = Math.max(...filtered);
  const range = max - min || 1;

  const points = filtered.map((v, i) => {
    const x = (i / (filtered.length - 1)) * width;
    const y = height - ((v - min) / range) * (height - 4) - 2; // 2px padding top/bottom
    return `${x},${y}`;
  });

  const polyline = points.join(' ');
  const fillPoints = `0,${height} ${polyline} ${width},${height}`;

  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} style={{ display: 'block' }}>
      {fill && <polygon points={fillPoints} fill={color} opacity={0.12} />}
      <polyline points={polyline} fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
